export default class eCardRecipient {
    constructor(Name = '', Email = '') {
        this.Name = Name;
        this.Email = Email;
    }

    // TODO: Add isValid method
}
